import React from "react";
import ButtonLink from "../utils/ButtonLink";
import classes from "./EmptyCart.module.css";
export default function EmptyCart(props) {
  return (
    <div className={classes.emptyCart}>
      <h2>Your Cart is Empty </h2>
      <ButtonLink style={{ width: "100%" }} to="/all-products">
        {props.children}
      </ButtonLink>
    </div>
  );
}
